import { getBackVersion } from '../../../config';
import api from '../../api';
import { RentAdvanceUseTermsSnapshot } from '../../../models/LandlordArea/RentAdvance';

const latestUseTermsVersion = 'v0.1';

const getUseTerms = (): Promise<RentAdvanceUseTermsSnapshot> =>
    api.request<RentAdvanceUseTermsSnapshot>({
        method: 'GET',
        url: `${getBackVersion()}/landlord_area/rent_advances/use_terms/${latestUseTermsVersion}`,
    });

type AcceptUseTermsArgs = {
    latitude: number | undefined;
    longitude: number | undefined;
};

const acceptUseTerms = ({
    latitude,
    longitude,
}: AcceptUseTermsArgs): Promise<RentAdvanceUseTermsSnapshot> =>
    api.request<RentAdvanceUseTermsSnapshot>({
        method: 'POST',
        url: `${getBackVersion()}/landlord_area/rent_advances/use_terms/${latestUseTermsVersion}`,
        data: { latitude, longitude },
    });

export { acceptUseTerms, getUseTerms };
export type { AcceptUseTermsArgs };
